import axios from "axios";
import NProgress from "nprogress";
import RouterUtils from "../../utils/BaseUtils/RouterUtils";
// import Vue from "vue";

const apiClient = axios.create({
  baseURL: window.__env.api.baseUrl,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
  timeout: 50000
});

apiClient.interceptors.request.use(config => {
  NProgress.start();
  return config;
});
apiClient.interceptors.response.use(response => {
  NProgress.done();
  if (response.data.responseCode === "92") {
    RouterUtils.changeRouteTo("login");
  }
  return response;
});

export default {
  login(payload) {
    return apiClient.post("/logon", JSON.stringify(payload));
  },
  changeDefaultPassword(payload) {
    return apiClient.post("/changeDefaultPassword", JSON.stringify(payload));
  },
  logout(payload) {
    return apiClient.post("/logOut", JSON.stringify(payload));
  },
  validateUserToken(payload) {
    return apiClient.post("/validateUserToken", JSON.stringify(payload));
  }
};
